// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__mkcsS","content":"GlobalSearch_content__3GsvS"};